import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React from "react";
import {
  P,
  SectionHeading,
  SectionWrapper,
} from "../../../Styles/style";

import EXPLORE from "../../../../assets/images/EXPLORE.png";
import { useTheme } from "@emotion/react";
import OpenSource from "../../../Components/OpenSource";
import Availible from "../../../Components/Availible";

const MainGrid = styled(Grid)`
  padding: 80px 0 30px;
  justify-content: center;
  text-align: LEFT;
`;
const GridImg = styled(Grid)`
  /* text-align-last: right; */
`;
const GridText = styled(Grid)`
  padding: 80px 0 0;
`;
// const LearnBuutt = styled.a`
//   border: 1px solid ${(props) => props.theme.textPrimary};
//   color: ${(props) => props.theme.textPrimary};
//   padding: 7px 20px;
//   text-decoration: none;
// `;
const MetAMskimg = styled.img`
  width: 100%;
  max-width: 350px;
`;

const S6_ExploreDapps = () => {
  const theme = useTheme();
  return (
    <div>
      <SectionWrapper p="4rem 0" id="features">
        <Container maxWidth="xl">
          <MainGrid container rowGap={2}>
            {/* <Grid item xs={2} /> */}
            <GridImg
              item
              xs={12}
              md={5}
              data-aos="zoom-in"
              data-aos-easing="ease-in"
              data-aos-delay="300"
              data-aos-offset="0"
              data-aos-duration="1000"
            >
              <MetAMskimg src={EXPLORE} />
            </GridImg>
            <GridText
              item
              xs={12}
              md={5}
              data-aos="fade-up"
              data-aos-anchor-placement="top-bottom"
              data-aos-delay="300"
              data-aos-offset="0"
              data-aos-duration="1000"
            >
              <SectionHeading
                data-aos="zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="300"
                data-aos-offset="0"
                data-aos-duration="1000"
              >
                Explore Dapps
              </SectionHeading>
              {/* <P p="5px 0 10px" m="0" data-aos="zoom-in"
                                data-aos-easing="ease-in"
                                data-aos-delay="700"
                                data-aos-offset="0"
                                data-aos-duration="300"><b>Securely Connect Incognito Wallet Browser Extension With Your
                                    Favorite Dapps.</b></P> */}
              <P
                data-aos="zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="300"
                data-aos-offset="0"
                data-aos-duration="1000"
              >
                Securely connect your Incognito Wallet browser extension with
                your favorite decentralized applications (DApps). Experience a
                privacy-focused and secure interaction with the DApps you love.
              </P>
              {/* <LearnBuutt
                href="#"
                target="blank"
                data-aos="zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="700"
                data-aos-offset="0"
                data-aos-duration="300"
              >
                Learn More
              </LearnBuutt> */}
            </GridText>
          </MainGrid>
        </Container>
      </SectionWrapper>
      <OpenSource
        link1st="#"
        bgcolor1st={theme.Approvecolor}
        heading1st="Audit Report"
        link2nd="#"
        bgcolor2nd={theme.btnSecondary}
        heading2nd="Github"
        link3rd="#"
        bgcolor3rd={theme.btnPrimary}
        heading3rd="Documentation"
      />
      <Availible />
    </div>
  );
};

export default S6_ExploreDapps;
